import React, { createContext, useContext, useState, useEffect } from 'react';
import { HistoryService, SavedReport } from '../services/historyService';

interface HistoryContextType {
  history: SavedReport[];
  latestReport: SavedReport | undefined;
  saveReport: (report: SavedReport) => void;
  deleteReport: (id: string) => void;
  refreshHistory: () => void;
}

const HistoryContext = createContext<HistoryContextType>({
  history: [],
  latestReport: undefined,
  saveReport: () => {},
  deleteReport: () => {},
  refreshHistory: () => {}
});

export const HistoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [history, setHistory] = useState<SavedReport[]>([]);
  const [latestReport, setLatestReport] = useState<SavedReport | undefined>(undefined);

  const refreshHistory = () => {
    const data = HistoryService.getHistory();
    setHistory(data);
    setLatestReport(data.length > 0 ? data[0] : undefined);
  };

  useEffect(() => {
    refreshHistory();
  }, []);

  const saveReport = (report: SavedReport) => {
    HistoryService.saveReport(report);
    refreshHistory();
  };

  const deleteReport = (id: string) => {
    HistoryService.deleteReport(id);
    refreshHistory();
  };

  return (
    <HistoryContext.Provider value={{ history, latestReport, saveReport, deleteReport, refreshHistory }}>
      {children}
    </HistoryContext.Provider>
  );
};

export const useHistory = () => useContext(HistoryContext);
